module.exports = __webpack_public_path__ + "static/media/left_quote.fd6c85f2.svg";